module.exports = __webpack_public_path__ + "Step6_Header_new.2bed046d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/desktop/headers/Step6_Header_new.png
// module id = 3gfu
// module chunks = 0